<template>
  <div>
    <div class="mb-8 flex justify-start max-w-3xl">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('projects')">Regresar</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        Editar Proyecto
      </h1>
     
    </div>
    <div class="flex flex-wrap">
    <div class="w-full">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(1)" v-bind:class="{'text-amber-600 bg-white': openTab !== 1, 'text-black bg-amber-600': openTab === 1}">
            Datos 
          </a>
        </li>
      <!--  <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(2)" v-bind:class="{'text-amber-600 bg-white': openTab !== 2, 'text-black bg-amber-600': openTab === 2}">
            Signos Vitales
          </a>
        </li>
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
          <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabs(3)" v-bind:class="{'text-amber-600 bg-white': openTab !== 3, 'text-black bg-amber-600': openTab === 3}">
            Contactos de Emergencia
          </a>
        </li>-->
      </ul>
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        
        <div class="px-4 py-5 flex-auto">
          <div class="tab-content tab-space">
            <div v-bind:class="{'hidden': openTab !== 1, 'block': openTab === 1}">
              <form @submit.prevent="update">
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <text-input v-model="form.name" :error="form.errors.name" :req="form.name" class="pb-8 pr-6 w-full lg:w-3/6" label="Nombre" required/>
          <div class="container pb-8 pr-6 w-full lg:w-3/6">
                <label class="form-label" >Empresa:</label>
            <v-select v-model="form.organization_id" :options="organizations" label="name"></v-select>
            </div>
          
          </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar</button>

          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Actualizar</loading-button>
        </div>
      </form>
            </div>
      <!--     <div v-bind:class="{'hidden': openTab !== 2, 'block': openTab === 2}">
              <p>
                Completely synergize resource taxing relationships via
                premier niche markets. Professionally cultivate one-to-one
                customer service with robust ideas.
                <br />
                <br />
                Dynamically innovate resource-leveling customer service for
                state of the art customer service.
              </p>
            </div>
            <div v-bind:class="{'hidden': openTab !== 3, 'block': openTab === 3}">
              <p>
                Efficiently unleash cross-media information without
                cross-media value. Quickly maximize timely deliverables for
                real-time schemas.
                <br />
                <br />
                Dramatically maintain clicks-and-mortar solutions
                without functional solutions.
              </p>
            </div>--> 
          </div>
        </div>
       
      </div>
    </div>
  </div>
   <!-- <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">  </div>-->
  </div>
</template>

<script>
import Layout from '@/Shared/LayoutMenu'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';



export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    vSelect,
    DatePicker,
  },
  layout: Layout,
  props: {
    project: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      openTab: 1,
      organizations: this.organizations,
      form: this.$inertia.form({
        _method: 'put',
        id: this.project.id,
        name: this.project.name,
        organization_id: this.project.organization.name,
      }),
    }
  },
  methods: {
    toggleTabs: function(tabNumber){
      this.openTab = tabNumber
    },
    update() {
      this.form.post(this.route('projects.update', this.project.id), {
      })
    },
    destroy() {
      if (confirm('Está seguro de Eliminar este Proyecto?')) {
        this.$inertia.delete(this.route('projects.destroy', this.project.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar este Proveedor?')) {
        this.$inertia.put(this.route('projects.restore', this.project.id))
      }
    },
  },
}
</script>